import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import ScrollToTop from "./components/ScrollToTop";
import { AuthProvider } from "./hooks/useAuth";
import HomePage from "./Pages/HomePage/HomePage";
import Login from "./Pages/Login/Login";
import LogUp from "./Pages/LogUp/LogUp";
import Explore from "./Pages/Explore/Explore";
import BookExpert from "./Pages/Explore/BookExpert";
import FreeChat from "./Pages/FreeChat/FreeChat";
import ChatInterface from "./Pages/FreeChat/ChatInterface";
import Community from "./Pages/Community/Community";
import Volunteering from "./Pages/Volunteering/Volunteering";
import Music from "./Pages/Music/Music";
import Subscription from "./Pages/Subscription/Subscription";
import StrangerChat1 from "./Pages/StrangerChat1/StrangerChat1";
import StrangerChat2 from "./Pages/StrangerChat2/StrangerChat2";
import AIChat from "./Pages/FreeChat/AIChat";
import { chatService } from './services';
import BookingDashboard from "./Pages/BookingDashboard/BookingDashboard";
import BookingConfirmation from "./Pages/BookingConfirmation/BookingConfirmation";
import PaymentResult from "./Pages/PaymentResult/PaymentResult";
import AppointmentCalendar from "./Pages/AppointmentCalendar/AppointmentCalendar";
import Profile from "./Pages/Profile/Profile";
import ConsultingPhysician from "./Pages/ConsultingPhysician/ConsultingPhysician";
import Questionnaire from "./Pages/Explore/Questionnaire";
import Credentials from "./Pages/Credentials/Credentials";
import APITest from "./components/APITest";

function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <AuthProvider>
        <div className="app-container">
          <ScrollToTop />
          <Routes>
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<LogUp />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/book-expert" element={<BookExpert />} />
        <Route path="/free-chat" element={<FreeChat />} />
  <Route path="/free-chat/messenger" element={<ChatInterface fullPage={true} />} />
        <Route path="/community" element={<Community />} />
        <Route path="/volunteering" element={<Volunteering />} />
        <Route path="/music" element={<Music />} />
        <Route path="/stranger-chat-1" element={<StrangerChat1 />} />
        <Route path="/stranger-chat-2" element={<StrangerChat2 />} />
        <Route path="/ai-chat" element={<AIChat onClose={() => window.history.back()} onSendMessage={async (message, options = {}) => {
          try {
            const res = await chatService.getAIResponse(message, options);
            // Return full response so the component can extract ConversationId and AssistantText
            return res;
          } catch (err) {
            console.error('AI chat error', err);
            return null;
          }
        }} />} />
        <Route path="/booking-dashboard" element={<BookingDashboard />} />
        <Route path="/booking-confirmation" element={<BookingConfirmation />} />
        <Route path="/payment-result" element={<PaymentResult />} />
        <Route path="/payment/success" element={<PaymentResult />} />
        <Route path="/appointment-calendar" element={<AppointmentCalendar />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile/:id" element={<Profile />} />
        <Route path="/consulting-physician" element={<ConsultingPhysician />} />
        <Route path="/questionnaire" element={<Questionnaire />} />
        <Route path="/credentials" element={<Credentials />} />
        <Route path="/api-test" element={<APITest />} />
          </Routes>
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;